<template>
  <div
    v-if="widthFilterOptions && Object.keys(widthFilterOptions).length"
    class="c-product-info__ring-width"
  >
    <h2 class="t-heading-7">
      WIDTH: <span class="t-paragraph">{{ width }}</span>
    </h2>
    <div class="c-product-info__ring-width-display">
      <component
        :is="componentName"
        v-if="widthFilterOptions.Halo"
        :to="widthFilterOptions.Halo.link"
        class="c-product-info__ring-width__link"
        @update:width="$emit('update:width', $event)"
      >
        <ring-width
          :width="widthFilterOptions.Halo.width"
          :active="isActive(widthFilterOptions.Halo)"
        />
      </component>
      <component
        :is="componentName"
        v-if="widthFilterOptions.Thin"
        :to="widthFilterOptions.Thin.link"
        class="c-product-info__ring-width__link"
        @update:width="$emit('update:width', $event)"
      >
        <ring-width
          v-if="widthFilterOptions.Thin"
          :width="widthFilterOptions.Thin.width"
          :active="isActive(widthFilterOptions.Thin)"
        />
      </component>
      <component
        :is="componentName"
        v-if="widthFilterOptions.Standard"
        :to="widthFilterOptions.Standard.link"
        class="c-product-info__ring-width__link"
        @update:width="$emit('update:width', $event)"
      >
        <ring-width
          v-if="widthFilterOptions.Standard"
          :width="widthFilterOptions.Standard.width"
          :active="isActive(widthFilterOptions.Standard)"
        />
      </component>
      <component
        :is="componentName"
        v-if="widthFilterOptions.Wide"
        :to="widthFilterOptions.Wide.link"
        class="c-product-info__ring-width__link"
        @update:width="$emit('update:width', $event)"
      >
        <ring-width
          v-if="widthFilterOptions.Wide"
          :width="widthFilterOptions.Wide.width"
          :active="isActive(widthFilterOptions.Wide)"
        />
      </component>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'
import ProductInfoWidthButton from './ProductInfoWidthButton'
import RingWidth from '../ringWidth/RingWidth'
export default {
  components: {
    ProductInfoWidthButton,
    RingWidth,
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    products: {
      type: Array,
      default: () => []
    },
    renderLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    componentName() {
      return (this.renderLink) ? 'nuxt-link' : 'product-info-width-button'
    },
    width() {
      const product = this.product
      return get(product, 'metafieldsMap.width.value', 'Standard');
    },
    color() {
      const product = this.product
      return get(product, 'metafieldsMap.color.value');
    },
    /**
     * grab relevant data points from the product list
     */
    filterOptionsData() {
      const products = this.products
      let filterData = {}
      for (let prod of (products || [])) {
        const width = get(prod, 'metafieldsMap.width.value');
        const color = get(prod, 'metafieldsMap.color.value');
        if (!filterData[width]) {
          filterData[width] = { width, options: [] }
        }
        filterData[width].options.push({
          link: `/products/${prod.handle}`,
          color
        })
      }
      return filterData
    },
    /**
     * @typedef {{ width: string, active: boolean, link: string }} FilterOpt
     * @return {{ Halo: FilterOpt, Thin: FilterOpt, Standard: FilterOpt }}
     */
    widthFilterOptions() {
      const selectedWidth = this.width
      const selectedColor = this.color
      const filterData = this.filterOptionsData
      let filterOptions = {}
      // given what we know, generate the options
      for (let { width, options } of Object.values(filterData)) {
        // find the corresponding product link or a suitable fallback
        let activeLink = options[0].link
        for (let { link, color } of options) {
          try {
            if (color.name === selectedColor.name) {
              activeLink = link
              break
            }
          } catch (err) {
            console.error('MissingColorData', { color, selectedColor })
            throw new Error('MissingColorData', {
              cause: { color, selectedColor }
            })
          }
        }
        filterOptions[width] = {
          width,
          active: width === selectedWidth,
          link: activeLink
        }
      }
      return filterOptions
    },
  },
  methods: {
    isActive(width) {
      return (width && width.active)
        ? width.width
        : null
    }
  }
}
</script>

<style lang="scss" scoped>
.c-product-info__ring-width {
  @include themify($themes) {
    border-top: $border themed("foreground", "section-border");
  }
  &-display > * {
    display: inline-block;
    padding-right: rem(10px);
  }
  &__link {
    text-decoration: none;
    @include themify($themes) {
      color: themed("foreground");
    }
    :deep(button) {
      cursor: pointer;
    }
  }
}
</style>
